export default {
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Poradniki",
  "nav.faq": "FAQ",
  "nav.shoppingGuide": "Poradnik zakupowy",
  "nav.homeBtn": "Strona główna",

  "hero.badge": "Niezależne źródło zakupowe",
  "hero.title": "USFans Spreadsheet — szybciej znajdź produkty, sprzedawców i zasoby zakupowe",
  "hero.subtitle": "Poznaj USFans Spreadsheet, odkrywaj produkty i sprzedawców, porównuj przydatne zasoby oraz dowiedz się o wysyłce, magazynie, kontroli jakości i bezpieczeństwie zakupów.",
  "hero.ctaPrimary": "Otwórz USFans Spreadsheet",
  "hero.ctaSecondary": "Przeglądaj poradniki",
  "hero.searchPlaceholder": "Szukaj w USFans Spreadsheet, produkty, sprzedawcy lub kategorie...",

  "cta.usfans": "usfans spreadsheet",
  "cta.buynow": "kup teraz",

  "categories.dropdownLabel": "Wybierz kategorię",
  "categories.title": "Przeglądaj według kategorii",
  "categories.subtitle": "Wybierz kategorię poniżej, aby przejść prosto do pasujących produktów w głównym sklepie.",

  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna / Majtki",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  "articles.title": "Najnowsze poradniki i zasoby",
  "articles.subtitle": "Oryginalne poradniki, które pomogą Ci mądrzej robić zakupy z USFans Spreadsheet.",
  "articles.readMore": "Czytaj artykuł",
  "articles.minRead": "min czytania",

  "content.title": "Czym jest USFans Spreadsheet?",
  "content.p1": "USFans Spreadsheet to poręczna referencja, która gromadzi kategorie produktów i linki do sprzedawców w jednym miejscu. Zamiast szukać w sieci, otwierasz kategorię i przechodzisz prosto do tego, czego szukasz — od butów i bluz po torby, paski i perfumy.",
  "content.p2": "Każda kategoria prowadzi do dedykowanej strony w głównym sklepie, więc zawsze trafiasz tam, gdzie naprawdę są produkty. To sprawia, że przeglądanie jest szybsze i wszystko jest uporządkowane według typu.",
  "content.cta": "Otwórz USFans Spreadsheet",

  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Szybkie odpowiedzi o tym, jak działa USFans Spreadsheet.",

  "safety.title": "Kupuj z pewnością",
  "safety.text": "To niezależne źródło informacji. Zawsze weryfikuj szczegóły produktu, ceny i wysyłkę bezpośrednio w sklepie przed zakupem.",
  "safety.disclaimer": "USFansLink.club to niezależne źródło informacji i nie powinno być przedstawiane jako oficjalna strona USFans, chyba że zweryfikowano oficjalną relację.",

  "footer.disclaimer": "USFansLink.club to niezależne źródło informacji i nie jest powiązane z żadnym wymienionym sklepem. Wszystkie linki zewnętrzne otwierają się w nowej karcie.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",

  "article.back": "Wróć do strony głównej",
  "article.updated": "Ostatnia aktualizacja",
  "article.pros": "Zalety",
  "article.cons": "Wady",
  "article.faq": "FAQ",
  "article.related": "Powiązane poradniki",
  "article.ctaTitle": "Gotowy do odkrywania?",
  "article.ctaText": "Przejdź do USFans Spreadsheet i zacznij przeglądać produkty i sprzedawców.",
  "article.ctaButton": "Otwórz USFans Spreadsheet",
};